// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LikeButton_wrapper__U50Fp","highlighted":"LikeButton_highlighted__3lvdo","withAnimation":"LikeButton_withAnimation__1s8V-","swing":"LikeButton_swing__2uEIi"};